import { TriangleAlert } from "lucide-react";

import { Alert, AlertDescription } from "@/components/ui/alert";

const ErrorMessages = ({ messages }: { messages: string[] }) => (
  <div className="space-y-2">
    {messages.map((message, index) => (
      <Alert key={`${message}-${index}`} variant="destructive">
        <TriangleAlert aria-hidden="true" />
        <AlertDescription>{message}</AlertDescription>
      </Alert>
    ))}
  </div>
);

export { ErrorMessages };
